var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { AfterViewInit, OnInit, Renderer2, ElementRef, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { Store, Select, Actions, ofActionDispatched } from '@ngxs/store';
import { EnginePositionModel } from 'src/app/engine/models/engine-position.model';
import { EngineVisibilityEnum } from 'src/app/engine/models/engine-visibility.enum';
import { SetEnginePosition, ClickNode, SetActiveTool, SetDisplay, PlayAnimation } from 'src/app/engine/state/engine.actions';
import { LoadStory, SetIncomingStory, LoadStoryFail } from 'src/app/story/state/story.actions';
import { StoryState } from 'src/app/story/state/story.state';
import { Observable, Subject, combineLatest, BehaviorSubject } from 'rxjs';
import { filter, takeUntil, map, take, delay, first, pairwise } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { EngineState } from 'src/app/engine/state/engine.state';
import { SetTheme } from 'src/app/layout/state/layout.actions';
import { LayoutThemeEnum } from 'src/app/layout/models/layout-theme.enum';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { ToolEnum } from 'src/app/engine/models/tool.enum';
import { ViewState } from '../../state/view.state';
import { AnimationService } from 'src/app/engine/animation.service';
import { SelectBookmark } from 'src/app/bookmarks/state/bookmarks.actions';
import { BookmarksState } from 'src/app/bookmarks/state/bookmarks.state';
import { BookmarkActionsEnum } from 'src/app/bookmarks/components/bookmark-actions/bookmark-actions.component';
import { LockCamera, SetCamera } from 'src/app/engine/state/camera/engine.camera.actions';
import { EngineNodesState } from 'src/app/engine/state/nodes/engine.nodes.state';
import { SelectChapter, RecordChapterVisibilityState, NextChapter, PreviousChapter } from 'src/app/story/state/chapters/story.chapters.actions';
import { SetCheckedNodes, CheckNode, SelectNode, ExpandNode, ToggleVisibleNodes, ResetEngineNodes, Isolate } from 'src/app/engine/state/nodes/engine.nodes.actions';
import { HistoryService } from 'src/app/history/history.service';
import { CacheChapterSynchronization, ClearHistory, ResetHistory, CopyChapterSynchronization } from 'src/app/history/state/history.actions';
import { AuthState } from 'src/app/auth/state/auth/auth.state';
import { DialogService } from 'src/app/dialogs/dialog.service';
import { ExploreService } from 'src/app/explore/explore.service';
import { EnableContextLabel, ResetLabels } from 'src/app/story/state/labels/story.labels.actions';
import { PaintService } from 'src/app/engine/paint.service';
import { ResetView, ShowColumn } from '../../state/view.actions';
import { PaintPresetFade } from 'src/app/engine/models/paint-presets.const';
import { TreeTheme } from 'src/app/shared/components/tree/tree/tree.component';
import { FormControl } from '@angular/forms';
import { SetObjectVisibility } from 'src/app/edit/state/edit.actions';
import { StoryService } from 'src/app/story/story.service';
var ViewComponent = /** @class */ (function () {
    function ViewComponent(activatedRoute, renderer, store, actions, location, animationService, historyService, exploreService, dialogService, paintService, storyService, router) {
        this.activatedRoute = activatedRoute;
        this.renderer = renderer;
        this.store = store;
        this.actions = actions;
        this.location = location;
        this.animationService = animationService;
        this.historyService = historyService;
        this.exploreService = exploreService;
        this.dialogService = dialogService;
        this.paintService = paintService;
        this.storyService = storyService;
        this.router = router;
        this.treeTheme = TreeTheme;
        this.bookmarkActions = BookmarkActionsEnum;
        this.isAnimated = false;
        this.interactive = false;
        this.animationReady = false;
        this.showScrubber = false;
        this.showPlayPause = false;
        this.query = '';
        this.selectedColumnGroup = 'Description';
        this.windowSize$ = new BehaviorSubject(window.innerWidth);
        this.searchControl = new FormControl('');
        this.ngUnsubscribe = new Subject();
    }
    ViewComponent.prototype.ngOnInit = function () {
        this.initListeners();
        this.initKeyboardListeners();
        this.store.dispatch(new SetTheme(LayoutThemeEnum.Light));
        this.store.dispatch(new ResetLabels());
        this.store.dispatch(new ResetView());
        this.store.dispatch(new ResetHistory());
        this.store.dispatch(new SetActiveTool(ToolEnum.Select));
        this.store.dispatch(new LockCamera(false));
        this.store.dispatch(new SetDisplay(true));
        this.store.dispatch(new EnableContextLabel(true));
        var id = this.activatedRoute.snapshot.queryParams.id;
        this.id = this.sanitizeRouteId(id);
        this.type = this.storyService.getStoryType(this.id);
        this.store.dispatch(new SetIncomingStory(this.id, this.type, true));
        // set story metadata
        this.store.dispatch(new SelectBookmark(this.id, this.type));
    };
    ViewComponent.prototype.ngOnDestroy = function () {
        // #TODO: Put theme management in route
        // Change the theme
        this.store.dispatch(new SetTheme(LayoutThemeEnum.Light));
        this.store.dispatch(new ResetEngineNodes());
        this.store.dispatch(new SetDisplay(false));
        this.unbindKeyboardListeners();
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    ViewComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            _this.checkColumnVisible();
            _this.resizeEngineContainer();
        }, 0);
        // Choose default column. Don't default to description when it's empty.
        this.selectedChapter$.pipe(filter(function (chapter) { return chapter !== null; }), first(), takeUntil(this.ngUnsubscribe)).subscribe(function (chapter) {
            _this.chooseColumn(chapter);
        });
    };
    ViewComponent.prototype.initListeners = function () {
        var _this = this;
        // Only check column visibility when we pass the responsive breakpoint
        this.windowSize$.pipe(pairwise(), filter(function (_a) {
            var _b = __read(_a, 2), oldWidth = _b[0], newWidth = _b[1];
            return ((oldWidth <= 768 && newWidth > 768) ||
                (oldWidth >= 768 && newWidth < 768));
        })).subscribe(function (_a) {
            var _b = __read(_a, 2), oldWidth = _b[0], newWidth = _b[1];
            _this.checkColumnVisible();
        });
        // Window has resized, let the 3D canvas know
        this.renderer.listen('window', 'resize', function () {
            _this.windowSize$.next(window.innerWidth);
            _this.resizeEngineContainer();
        });
        combineLatest(this.engineReady$, this.incoming$).pipe(filter(function (_a) {
            var _b = __read(_a, 2), ready = _b[0], incoming = _b[1];
            return ready && !!incoming.id;
        }), takeUntil(this.ngUnsubscribe)).subscribe(function () {
            _this.store.dispatch(new SelectChapter()); // null chapter state
            _this.loadStory();
        });
        this.searchControl.valueChanges
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (query) {
            _this.query = query;
        });
        this.bookmark$
            .pipe(filter(function (bookmark) { return bookmark != null; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (bookmark) {
            _this.getCategory(bookmark);
        });
        combineLatest(this.bookmark$, this.userProfile$)
            .pipe(filter(function (_a) {
            var _b = __read(_a, 2), bookmark = _b[0], profile = _b[1];
            return bookmark != null && profile != null;
        }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (_a) {
            var _b = __read(_a, 2), bookmark = _b[0], profile = _b[1];
            _this.handlePremiumContent(bookmark, profile);
        });
        // Listen for clicked nodes
        this.actions
            .pipe(ofActionDispatched(ClickNode), takeUntil(this.ngUnsubscribe))
            .subscribe(function (action) {
            _this.handleNodeClicked(action.node, action.event);
        });
        this.selectedChapter$.pipe(filter(function (chapter) { return chapter != null; }), takeUntil(this.ngUnsubscribe)).subscribe(function (chapter) {
            _this.interactive = chapter.readyState.model;
            _this.handleAnimationReady(chapter);
        });
        this.selectedChapterId$
            .pipe(filter(function (chapter) { return chapter != null; }), map(function () { return _this.store.selectSnapshot(StoryChaptersState.getSelectedChapter); }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (chapter) {
            _this.handleChapterChange(chapter);
        });
        this.actions
            .pipe(ofActionDispatched(ToggleVisibleNodes), takeUntil(this.ngUnsubscribe))
            .subscribe(function (action) {
            if (action.recordHistory) {
                _this.historyService.recordViewGraphHistory();
            }
        });
        // content not found
        this.actions
            .pipe(ofActionDispatched(LoadStoryFail), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.store.dispatch(new SetIncomingStory(null, null));
            _this.router.navigate(['/404',], {
                queryParams: {
                    errorType: 'content',
                    errorUrl: _this.router.url
                },
                skipLocationChange: false,
                replaceUrl: true
            });
        });
    };
    ViewComponent.prototype.initKeyboardListeners = function () {
        var _this = this;
        // Tool switching
        Mousetrap.bind('1', function () { return _this.store.dispatch(new SetActiveTool(ToolEnum.Select)); });
        Mousetrap.bind('2', function () { return _this.store.dispatch(new SetActiveTool(ToolEnum.Hide)); });
        Mousetrap.bind('3', function () { return _this.store.dispatch(new SetActiveTool(ToolEnum.Fade)); });
        // Column toggles
        Mousetrap.bind('meta+,', function (event) {
            event.preventDefault();
            _this.collapseColumn();
        });
        // Chapter browser
        Mousetrap.bind('.', function () { return _this.store.dispatch(new NextChapter()); });
        Mousetrap.bind(',', function () { return _this.store.dispatch(new PreviousChapter()); });
        // Delete
        Mousetrap.bind(['del', 'backspace'], function () { return _this.handleDelete(); });
    };
    ViewComponent.prototype.unbindKeyboardListeners = function () {
        Mousetrap.unbind(['1', '2', '3', 'meta+,', '.', ',', 'del', 'backspace']);
    };
    ViewComponent.prototype.getCategory = function (bookmark) {
        this.category = this.exploreService.getBookmarkCategory(bookmark);
    };
    ViewComponent.prototype.handlePremiumContent = function (bookmark, profile) {
        var _this = this;
        if (bookmark.premium && !profile.premium_account_valid) {
            var dialogRef = this.dialogService.openPremiumContentDialog();
            dialogRef.afterClosed()
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(function (confirmed) {
                if (confirmed) {
                    _this.dialogService.openUpgradeDialog();
                }
                // always redirect
                _this.router.navigate(['/dashboard']);
            });
        }
    };
    ViewComponent.prototype.handleDelete = function () {
        var selectedNodes = this.store.selectSnapshot(EngineNodesState.getCheckedNodes);
        this.store.dispatch(new SetObjectVisibility(selectedNodes, false));
    };
    ViewComponent.prototype.chooseColumn = function (chapter) {
        // Ensure we select a default column
        if (!this.selectedColumnGroup) {
            this.selectedColumnGroup = 'Description';
        }
        // Don't show description column if it's empty
        if (this.selectedColumnGroup === 'Description' && chapter.info.description.length === 0) {
            this.selectedColumnGroup = 'Anatomy';
        }
    };
    ViewComponent.prototype.checkColumnVisible = function () {
        var _this = this;
        setTimeout(function () {
            var showColumn = (window.innerWidth > 768);
            _this.store.dispatch(new ShowColumn(showColumn));
        });
    };
    ViewComponent.prototype.resizeEngineContainer = function () {
        var _this = this;
        // Placed inside a timeout to let any conditional visibility of elements permeate first. This way,
        // engine is more likely to measure the accurate visible space it belongs to.
        setTimeout(function () {
            var _a = _this.engineContainer.nativeElement, offsetLeft = _a.offsetLeft, offsetTop = _a.offsetTop, offsetWidth = _a.offsetWidth, offsetHeight = _a.offsetHeight;
            var position = new EnginePositionModel(offsetLeft, offsetTop, offsetWidth, offsetHeight, EngineVisibilityEnum.Shown);
            _this.store.dispatch(new SetEnginePosition(position));
        });
    };
    ViewComponent.prototype.loadStory = function () {
        var _a = this.store.selectSnapshot(StoryState.getIncomingStoryInfo), id = _a.id, type = _a.type;
        this.store.dispatch(new LoadStory(id, type)).subscribe();
    };
    /**
     * Handlers
     */
    ViewComponent.prototype.handleChapterChange = function (chapter) {
        var _this = this;
        this.store.dispatch(new SetCamera(chapter.camera.location));
        this.store.dispatch(new CacheChapterSynchronization('root', chapter.id, chapter.synchronization, true));
        this.store.dispatch(new CopyChapterSynchronization('root', chapter.id, 'cache', chapter.id));
        this.viewGraph$
            .pipe(take(1), delay(1)).subscribe(function () {
            _this.clearHistory();
        });
    };
    ViewComponent.prototype.handleAnimationReady = function (chapter) {
        this.animationReady = chapter.readyState.animation;
        this.isAnimated = this.animationService.isChapterAnimated(chapter);
        if (this.isAnimated && this.animationReady) {
            this.store.dispatch(new PlayAnimation(true));
        }
    };
    ViewComponent.prototype.handleNodeClicked = function (node, event) {
        if (!node && !event.srcEvent.shiftKey) {
            this.store.dispatch(new SetCheckedNodes([]));
        }
        else if (event.srcEvent.shiftKey) {
            var checked = this.store.selectSnapshot(EngineNodesState.getCheckedNodes).some(function (value) { return value.id === node.id; });
            this.store.dispatch(new CheckNode(node, !checked));
            this.store.dispatch(new SelectNode(node));
        }
        else {
            var tool = this.store.selectSnapshot(EngineState.getActiveTool);
            var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
            switch (tool) {
                case ToolEnum.Hide:
                    this.handleToggleVisibleNodes({ nodes: [node], visible: false });
                    break;
                case ToolEnum.Select:
                    var checked = this.store.selectSnapshot(EngineNodesState.getCheckedNodes).some(function (value) { return value.id === node.id; });
                    (checked) ?
                        this.store.dispatch(new SetCheckedNodes([])) :
                        this.store.dispatch(new SetCheckedNodes([node]));
                    this.store.dispatch(new SelectNode(node));
                    this.store.dispatch(new ExpandNode(node));
                    break;
                case ToolEnum.Isolate:
                    this.store.dispatch(new Isolate([node], viewGraph));
                    break;
                case ToolEnum.Fade:
                    this.paintService.paint(node, PaintPresetFade.recipe);
                    break;
            }
        }
    };
    ViewComponent.prototype.handleToggleVisibleNodes = function (event) {
        this.store.dispatch(new ToggleVisibleNodes(event.nodes, event.visible));
        this.store.dispatch(new SetCheckedNodes([]));
        this.store.dispatch(new RecordChapterVisibilityState(event.nodes, event.visible, true));
    };
    ViewComponent.prototype.handleCollapseClick = function () {
        this.collapseColumn();
    };
    ViewComponent.prototype.collapseColumn = function () {
        var _this = this;
        var showColumn = this.store.selectSnapshot(ViewState.getShowColumn);
        this.store.dispatch(new ShowColumn(!showColumn));
        var interval = setInterval(function () {
            _this.resizeEngineContainer();
        }, 20);
        setTimeout(function () {
            clearInterval(interval);
        }, 300);
    };
    ViewComponent.prototype.handleSearchKeyup = function (event) {
        if (event.key === 'Escape') {
            this.clearSearchQuery();
            this.searchInput.nativeElement.blur();
        }
    };
    ViewComponent.prototype.clearHistory = function () {
        this.store.dispatch(new ClearHistory());
        this.historyService.recordViewGraphHistory();
    };
    ViewComponent.prototype.clearSearchQuery = function () {
        this.searchControl.setValue('');
    };
    // Bookmark routes use appropriate ID parameters, but internal users would like the ability to paste
    // in legacy paths. This means stripping out the .json extension at time of page load and accounting
    // for that conversion later on. 
    ViewComponent.prototype.sanitizeRouteId = function (id) {
        id = id.replace(/\.json$/, '');
        var query = "?id=" + id;
        this.location.replaceState('view', query);
        return id;
    };
    __decorate([
        Select(BookmarksState.getSelectedBookmark),
        __metadata("design:type", Observable)
    ], ViewComponent.prototype, "bookmark$", void 0);
    __decorate([
        Select(StoryState.getStory),
        __metadata("design:type", Observable)
    ], ViewComponent.prototype, "story$", void 0);
    __decorate([
        Select(StoryState.getIncomingStoryInfo),
        __metadata("design:type", Observable)
    ], ViewComponent.prototype, "incoming$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapter),
        __metadata("design:type", Observable)
    ], ViewComponent.prototype, "selectedChapter$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapterId),
        __metadata("design:type", Observable)
    ], ViewComponent.prototype, "selectedChapterId$", void 0);
    __decorate([
        Select(StoryChaptersState.getStoryChapters),
        __metadata("design:type", Observable)
    ], ViewComponent.prototype, "storyChapters$", void 0);
    __decorate([
        Select(EngineState.getReady),
        __metadata("design:type", Observable)
    ], ViewComponent.prototype, "engineReady$", void 0);
    __decorate([
        Select(EngineState.getViewGraph),
        __metadata("design:type", Observable)
    ], ViewComponent.prototype, "viewGraph$", void 0);
    __decorate([
        Select(ViewState.getShowPanel),
        __metadata("design:type", Observable)
    ], ViewComponent.prototype, "showPanel$", void 0);
    __decorate([
        Select(ViewState.getShowColumn),
        __metadata("design:type", Observable)
    ], ViewComponent.prototype, "showColumn$", void 0);
    __decorate([
        Select(AuthState.getUserProfile),
        __metadata("design:type", Observable)
    ], ViewComponent.prototype, "userProfile$", void 0);
    return ViewComponent;
}());
export { ViewComponent };
